<template>
  <div style="background: #f2f2f6; height: 100%">
    <el-form size="mini" label-width="100px" class="demo-form-inline">
      <el-row>
        <el-col :span="10" style="text-align:left">
      <el-form-item :label="$t('base.timeInterval')">
    <el-date-picker
v-model="where.betweendate"
type="datetimerange"
:range-separator="$t('base.to')"
:start-placeholder="$t('base.beginTime')"
size="mini"
value-format="yyyy-MM-dd HH:mm:ss"
:default-time="['00:00:00','23:59:59']"
:end-placeholder="$t('base.endTime')">
</el-date-picker>
</el-form-item>
</el-col>
<el-col :span="5">
<el-form-item :label="$t('device.heatpumpSelect')">
<el-select
         size="mini"
         v-model="where.deviceid"
         
         clearable
       >
         <el-option
           v-for="item in heatpump"
           :key="item.innerid"
           :label="item.name"
           :value="item.innerid"
           v-if="item.subdevs<=($store.state.slavenum+1)"
         >
         </el-option>
       </el-select>
</el-form-item>
</el-col>
<el-col :span="5">
<el-form-item :label="$t('device.paramSelect')">
<el-select
         size="mini"
         v-model="where.dpid"
         
         filterable
         clearable
       >
         <el-option
           v-for="item in dplist"
           :key="item.dpid"
           :label=" $i18n.locale=='en'?(item.desc_en||item.desc): item.desc"
           :value="item.dpid"
         >
         </el-option>
       </el-select>
</el-form-item>
</el-col>
<el-col :span="4" style="text-align:right">
  <el-button size="small" type="primary" @click="searchLog()">{{$t("base.search")}}</el-button>
          <el-divider direction="vertical"></el-divider>
         <el-button :title="$t('base.export')"  type="success"  size="small" icon="el-icon-upload2" onclick="download('logtable','Operation Logs')"></el-button>
</el-col>
</el-row>
</el-form>
        <el-table
          id="logtable"
          :data="tabledata"
          v-loading="loading"
          ref="table"
          border
          stripe
          style="width: 100%; border-radius: 0 0 10px 10px;font-size:12px"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{'line-height': '20px', padding: '8px', 'text-align': 'center' }">
          <template slot="empty">
                 <div>{{ $t('device.noOptLog') }}
              </div>
             </template>
           <el-table-column
            type="index"
            :index="indexMethod"
            width="65">
          </el-table-column>
          <el-table-column
            prop="dname"
            :label="$t('device.deviceName')"  width="150">
          </el-table-column>

          <el-table-column prop="name" :label="$t('device.optParam')">
            <template slot-scope="scope">
             <span> {{  $i18n.locale=='en'?(scope.row.name_en||scope.row.name): scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="value" :label="$t('device.changeValue')" width="100">
          </el-table-column>
          <el-table-column prop="desc" :label="$t('device.desc')">
            <template slot-scope="scope">
             <span> {{  $i18n.locale=='en'?(scope.row.desc_en||scope.row.desc): scope.row.desc}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createdtime" :label="$t('device.optTime')" width="170">
          </el-table-column>
          <el-table-column prop="opt" :label="$t('device.optBy')" width="150">
            <template slot-scope="scope">
              {{getOptBy(scope.row)}}
        </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          :page-sizes="[10, 15, 30, 50, 100]"
          :current-page="pageset.index"
          :page-size="pageset.size"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total,sizes,prev, pager, next"
          :total="totalsize"
          style="float: right; margin-top: 10px;margin-bottom:10px"
        >
        </el-pagination>

  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'ErrorPage',
  data () {
    return {
      tabledata: [],
      loading: true,
      where:{
        projectid:this.$store.state.project.projectid,
        deviceid:'',
        betweendate: [],
        dpid:null
      },
      pageset: {
        size: 10,
        index: 1
      },
      totalsize: 0
    }
  },
  computed: {
    heatpump () {
      return this.$store.state.devicelist.filter(d => { return d.type == 'heatpump' })
    },
    dplist: {
      get () {
        if (this.$store.state.device && this.$store.state.device.innerid) {
          return this.$store.state.device.dplist.filter(d => { return (d.xrw === 1 || d.xrw === 3) && (!d.subhide || (d.subhide === 1 && this.$store.state.device.subdevs === 1) || (this.$store.state.device.subdevs > 1 && d.subhide > 1)) })
        } else {
          return []
        }
      },
      set (val) {
        this.$store.state.device.dplist = val.concat(this.fixedDp)
      }
    }
  },
  mounted: function () {
    var self = this
    let customer = window.localStorage.getItem('customer')
    if (customer) {
      if(this.$store.state.project.projectid){
        self.searchLog()
      }else{
        setTimeout(()=>{
          self.searchLog()
        },4000)
      }
        
    } else {
      this.$message({
        message: this.$t("base.noSession"),
        type: 'error'
      })
      self.$router.push({ name: 'Login' })
    }
  },
  methods: {
    searchLog () {
      this.where.projectid=this.$store.state.project.projectid
      var self = this
      self.loading = true
      Vue.axios
        .post('/equipment/history/log/list', {
          where: this.where,
          pageset: this.pageset
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.tabledata = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || this.$t("base.systemError"),
              type: 'error'
            })
          }
          self.loading = false
        })
      Vue.axios
        .post('/equipment/history/log/list/count', {
          where: this.where,
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.totalsize = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || this.$t("base.systemError"),
              type: 'error'
            })
          }
        })
    },
    indexMethod (index) {
      return (this.pageset.index - 1) * this.pageset.size + index + 1
    },
    handleSizeChange (val) {
      this.pageset.size = val
      this.searchLog()
    },
    handleCurrentChange (val) {
      this.pageset.index = val
      this.searchLog()
    },
    getOptBy(row){
      if(row.fname){
        return '厂家:'+row.fname
      }else if(row.pname){
        return '板商:'+row.pname
      }else if(row.dsname){
        return '经销商:'+row.dsname
      }else if(row.mobile){
        return row.mobile
      }else{
        return '--'
      }
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Devices/OptLog.vue